import { Button, Select, type SelectProps } from 'antd'

const defaultSelectStyle = { width: '100%', minWidth: '150px' }

interface SelectUserRolesProps {
  data: any[]
  placeholder?: string
  className?: string
  onChange?: (value: string[]) => void
  selectProps?: SelectProps
  onOpen?: () => void
  user?: any
  setUserRoles?: (user: any) => void
}

export const SelectUserRoles = ({ placeholder, className, onChange, selectProps, data = [] }: SelectUserRolesProps) => {
  const options = data.map((item) => ({
    value: item.id,
    label: item.name,
  }))

  const handleChange = (newValue: string[]) => {
    onChange?.(newValue)
  }

  return (
    <Button.Group className={className}>
      <Select
        className="border-secondary"
        maxTagCount="responsive"
        mode="multiple"
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        style={defaultSelectStyle}
        {...selectProps}
      />
    </Button.Group>
  )
}
